import { Link } from "react-router-dom";
import { BellRing, X } from "lucide-react";

export function TaskBanner({ task, onDismiss }) {
  if (!task) return null;
  return (
    <div className="tam-fade sticky top-14 lg:top-0 z-20 bg-[#D9232A] text-white px-4 sm:px-8 lg:px-10 py-3 flex items-center gap-3 text-sm" data-testid="task-alert-banner">
      <BellRing size={18} className="shrink-0 animate-pulse" />
      <p className="flex-1 min-w-0">
        <span className="font-semibold">New Purfleet task:</span> {task.stage} for <span className="font-semibold">{task.account_name}</span> raised by {task.created_by}
      </p>
      <Link to="/tasks" onClick={onDismiss} className="px-3 py-1.5 rounded-md bg-white text-[#D9232A] font-semibold hover:bg-slate-100 transition-colors" data-testid="task-alert-view-btn">View tasks</Link>
      <button onClick={onDismiss} className="p-1 hover:bg-white/10 rounded" data-testid="task-alert-dismiss-btn"><X size={16} /></button>
    </div>
  );
}
